import { AvertissementSalle } from './AvertissementSalle.js';
import { useState } from 'react';
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import { Button, Dialog } from '@artosera/ui';
import { useModifierSalle, useSalles } from '../../api/viewingRooms.js';
import { EtatDeSalle, texteSalle } from './salleUi.js';
import styles from './ViewingRoomDetailPage.module.css';

export function AjouterASalleDialog({
  galerieSlug,
  oeuvreId,
  onFermer,
}: {
  galerieSlug: string;
  oeuvreId: string;
  onFermer: () => void;
}) {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const salles = useSalles(galerieSlug, { page });
  const modifier = useModifierSalle(galerieSlug);
  return (
    <Dialog
      open
      onOpenChange={(open) => {
        if (!open) onFermer();
      }}
      title={t('regie:viewingRooms.ajouterASalle')}
      closeLabel={t('regie:viewingRooms.fermer')}
      description={t('regie:viewingRooms.sousTitre')}
    >
      <div className={styles.formulaire}>
        <AvertissementSalle galerieSlug={galerieSlug} oeuvreId={oeuvreId} />
        {salles.isLoading && <p role="status">{t('regie:viewingRooms.chargement')}</p>}
        {(salles.isError || modifier.isError) && (
          <p role="alert">{t('regie:viewingRooms.erreurs.generique')}</p>
        )}
        {salles.data?.salles.map((salle) => {
          const presente = salle.oeuvres.some((o) => o.id === oeuvreId);
          const complete = salle.oeuvres.length >= 40;
          return (
            <Button
              key={salle.id}
              variant="secondary"
              disabled={presente || complete || modifier.isPending}
              onClick={() =>
                modifier.mutate(
                  {
                    id: salle.id,
                    corps: { oeuvres: [...salle.oeuvres.map((o) => o.id), oeuvreId] },
                  },
                  { onSuccess: onFermer },
                )
              }
            >
              <span>
                {texteSalle(salle.titre, i18n.language)}
                {presente
                  ? ` · ${t('regie:viewingRooms.dejaPresente')}`
                  : complete
                    ? ` · ${t('regie:viewingRooms.complete')}`
                    : ''}
              </span>
              <EtatDeSalle etat={salle.etat} />
            </Button>
          );
        })}
        {(salles.data?.pagination.pages ?? 0) > 1 && (
          <div className={styles.actions}>
            <Button variant="ghost" disabled={page <= 1} onClick={() => setPage(page - 1)}>
              {t('regie:viewingRooms.precedente')}
            </Button>
            <Button
              variant="ghost"
              disabled={page >= (salles.data?.pagination.pages ?? 1)}
              onClick={() => setPage(page + 1)}
            >
              {t('regie:viewingRooms.suivante')}
            </Button>
          </div>
        )}
        <Button
          onClick={() => {
            onFermer();
            void navigate(
              `/${galerieSlug}/viewing-rooms?nouvelle=1&oeuvre=${encodeURIComponent(oeuvreId)}`,
            );
          }}
        >
          {t('regie:viewingRooms.nouvelleAvecOeuvre')}
        </Button>
      </div>
    </Dialog>
  );
}
